import { NavigateOptions, useLocation, useNavigate, useSearchParams } from 'react-router';

export const useCustomSearchParams = (): [
  URLSearchParams,
  (params: URLSearchParams, navigateOptions: NavigateOptions) => void,
] => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const setSearchParams = (params: URLSearchParams, navigateOptions: NavigateOptions) => {
    if (params.toString() === searchParams.toString()) {
      return;
    }

    navigate(
      {
        pathname: location.pathname,
        search: params.toString(),
        hash: location.hash,
      },
      navigateOptions,
    );
  };

  return [searchParams, setSearchParams];
};
